class SchedulePickerController {
    constructor() {
        'ngInject';
    }

    imageFor(imageType) {
        switch(imageType) {
            case "daily": return "daily.png"
            case "dailyTime": return "daily.png"
            case "dailyWallet": return "daily_wallet.png"
            case "complexProduct7": return "complex_product.png"
            case "complexProduct28": return "complex_product30.png"
            case "complex7": return "complex_product.png"
            case "complex28": return "complex_product30.png"
            case "taperTitrationCalendar": return "unknown.png"
            case "insulin": return "insulin.png"
            case "coag": return "unknown.png"
            default: return "unknown.png"
        }
    }

    isButtonEnabled() {
        return this.selectedSchedules.length && this.isFileReady
    }

    checkedOnPrint() {
        if (this.isButtonEnabled()) {
            this.onPrint();
        }
    }
}

export const SchedulePickerComponent = {
    name: 'schedulePicker',
    component: {
        template: `
        <div class="schedule-picker-content">
            <div class="section">
                <h1>View & Print:</h1>
                <span class="view-print-comment">Select schedules and action plans to preview, then click the button to print</span>
            
                <div class="schedule-print-btn">
                    <div class="btn btn-success"
                    data-ng-title="$ctrl.isButtonEnabled() ? 'Print' : 'Please select at least one schedule and wait for it to generate'" 
                    data-ng-class="$ctrl.isButtonEnabled() ? 'enabled' : 'disabled'" data-ng-click="$ctrl.checkedOnPrint()">Print</div> 
                </div>
                       
            </div>        
            
            <div class="schedule-option-list">
                <div class="schedule-option" data-ng-repeat="schedule in $ctrl.availableSchedules">
                    <input type="checkbox" data-ng-checked="$ctrl.selectedSchedules.includes(schedule.type)" data-ng-click="$ctrl.onScheduleSelectedToggle({scheduleType: schedule.type})" />
                    <img data-ng-src="app/img/schedule/{{$ctrl.imageFor(schedule.type)}}"/>
                    <div>
                        <span class="schedule-label">{{schedule.label}}</span>
                        <span class="schedule-description">{{schedule.description}}</span>            
                    </div>
                </div>
            </div>        
        </div>
        `,
        controller: SchedulePickerController,
        bindings: {
            availableSchedules: '<',
            selectedSchedules: '<',
            isFileReady: '<',
            onScheduleSelectedToggle: '&',
            onPrint: '&'
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/schedulePicker.component.js